import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  counselCodeList() {
    return core.call({
      url: '/api/v1/counsel/code/list',
      method: 'post',
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  counselSend(parameters={}) {
    return core.call({
      url: '/api/v1/counsel/send',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  counselReportList(parameters={}) {
    return core.call({
      url: '/api/v1/counselReportList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  }
}
